module.exports = __webpack_public_path__ + "img/login_bg_new1.7b99cc61.png";